module.exports = __webpack_public_path__ + "images/covenanthealth-white-trans.png";


//////////////////
// WEBPACK FOOTER
// ./assets/covenanthealth-white-trans.png
// module id = 3
// module chunks = 0